import { boot } from 'quasar/wrappers';
import FormWrapper from 'src/components/forms/wrapper.vue';
import PageSubheader from 'src/components/page/subheader.vue';

export default boot(({ app }) => {
    app.component('form-wrapper', FormWrapper);
    app.component('page-subheader', PageSubheader);
});
